import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Pipette } from "lucide-react";

const PRESETS = ["#082D4A", "#D4A017", "#3B82F6", "#8B5CF6", "#0EA5E9", "#D97706", "#DB2777", "#059669", "#7C3AED", "#DC2626"];
const isHex = (v) => /^#([0-9a-f]{6})$/i.test(v);

export function CustomColorPicker({ initial = "#082D4A", onApply, onCancel }) {
  const start = isHex(initial) ? initial : "#082D4A";
  const [value, setValue] = useState(start);
  const [text, setText] = useState(start);
  const pick = (v) => { setValue(v); setText(v); };
  const commitText = (raw) => {
    let v = (raw || "").trim();
    if (v && v[0] !== "#") v = "#" + v;
    setText(v);
    if (isHex(v)) setValue(v.toLowerCase());
  };
  const eyedrop = async () => {
    if (!window.EyeDropper) return;
    try { const ed = new window.EyeDropper(); const r = await ed.open(); pick(r.sRGBHex); } catch { /* cancelled */ }
  };
  return (
    <div className="space-y-4" data-testid="custom-color-picker">
      <div className="grid grid-cols-5 gap-2">
        {PRESETS.map((c) => (
          <button key={c} type="button" data-testid={`picker-preset-${c}`} onClick={() => pick(c)}
            className={`h-8 w-8 rounded-full ring-2 transition-transform hover:scale-110 ${value.toLowerCase() === c.toLowerCase() ? "ring-[#082D4A]" : "ring-black/10"}`}
            style={{ backgroundColor: c }} />
        ))}
      </div>
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 shrink-0 rounded-lg ring-1 ring-black/10" style={{ backgroundColor: value }} data-testid="picker-preview" />
        <label className="relative h-11 w-11 shrink-0 cursor-pointer overflow-hidden rounded-lg ring-1 ring-[#D8E0E8]" title="Colour wheel">
          <input type="color" value={value} onChange={(e) => pick(e.target.value)} data-testid="picker-wheel" className="absolute -left-2 -top-2 h-16 w-16 cursor-pointer" />
        </label>
        <Input value={text} onChange={(e) => commitText(e.target.value)} placeholder="#0B2D4A" data-testid="picker-hex-input" className="font-mono uppercase" maxLength={7} />
        {typeof window !== "undefined" && window.EyeDropper && (
          <Button type="button" size="icon" variant="outline" onClick={eyedrop} data-testid="picker-eyedropper" title="Pick a colour from the screen"><Pipette size={18} /></Button>
        )}
      </div>
      <div className="flex justify-end gap-2">
        <Button variant="ghost" onClick={onCancel} data-testid="picker-cancel">Cancel</Button>
        <Button onClick={() => onApply(value)} disabled={!isHex(text)} data-testid="picker-apply" className="bg-[#082D4A] hover:bg-[#08223A]">Apply colour</Button>
      </div>
    </div>
  );
}
